import {Component} from '@angular/core';

@Component({
    selector: 'admin-footer',
    templateUrl: './admin-footer.template.html',
    styles: [`.site-footer {position: fixed;bottom: 0;width: calc(100% - 260px);height: 30px;line-height: 30px;padding: 0 25px;}`]
})

export class AdminFooterComponent {
    data  : any;

    constructor() {

    }
}


// WEBPACK FOOTER //
// /app/src/app/layout/footer/admin-footer.component.ts